import { Component, Input, OnInit } from '@angular/core';
import { IData } from '../../interfaces/data.interface';
import constants from 'src/config/constants';
import { DataValues } from 'src/app/utils/enums/data-values';

@Component({
  selector: 'custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.css']
})
export class CustomFooterComponent implements OnInit {
  @Input() dataInfo: IData[] = [];
  email: string = '';
  youtube: string = '';
  instagram: string = '';
  companyName: string = '';

  ngOnInit(): void {
    this.email = this.dataInfo.find((item: any) => item.typeDataName === DataValues.EMAIL)?.dataValue!;
    this.youtube = `https://${this.dataInfo.find((item: any) => item.typeDataName === DataValues.YOUTUBE)?.dataValue!}`;
    this.instagram = `https://${this.dataInfo.find((item: any) => item.typeDataName === DataValues.INSTAGRAM)?.dataValue!}`;
    this.companyName = `${this.dataInfo.find((item: any) => item.typeDataName === DataValues.COMPANY_NAME)?.dataValue!}`;
  }
}
